export default "__VITE_ASSET__CWjSCNBi__"